import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { getClaimKey } from '../../../../functions/get-claim-key';
import { HrFieldsResponse } from '../../../../models/api/view/claim/details/custom-fields/hr-fields-response';
import { BaseComponent } from '../../../base/base.component';
import { DatePickerComponent } from '../../../core/controls/date-picker.component';
import { SsnLabelComponent } from '../../../core/labels/ssn-label.component';
import { ActionRowComponent } from '../../../core/panels/action-row.component';
import { LoadingPanelComponent } from '../../../core/panels/loading-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';

@Component({
  selector: 'app-hr-custom-fields',
  imports: [
    TableComponent,
    ColumnComponent,
    RouterModule,
    DatePickerComponent,
    ActionRowComponent,
    SsnLabelComponent,
    LoadingPanelComponent,
  ],
  template: `
    <app-loading-panel [state]="loading ? 'Loading' : 'Loaded'" [error]="error">
      <ng-template #loaded>
        <app-action-row>
          <div class="tw-w-64" right1>
            <app-date-picker
              [control]="effectiveDate"
              [showHelpText]="false"
              label="As of"
            ></app-date-picker>
          </div>
        </app-action-row>

        <app-table
          [dataSource]="hrFields"
          [showPaginator]="false"
          [scrollable]="false"
          recordLabel="HR field"
          recordLabelCase="none"
          recordLabelPlural="HR fields"
          emptyRecordLabelCase="none"
          [sortField]="'fieldNumber'"
          [sortOrder]="1"
        >
          <app-column name="fieldNumber" label="Field #" />
          <app-column name="fieldName" label="Field" classes="tw-font-bold" />
          <app-column name="fieldValue" label="value">
            <ng-template #value let-data>
              @if (
                data.isSsn &&
                data.fieldName.toLowerCase() === 'employee id' &&
                !data.fieldValue.includes('***')
              ) {
                <app-ssn-label [value]="data.fieldValue" />
              } @else {
                <span>{{ data.fieldValue }}</span>
              }
            </ng-template>
          </app-column>
          <app-column name="dateEffective" label="effective Date" format="d" />
        </app-table>
      </ng-template>
    </app-loading-panel>
  `,
  styles: ``,
})
export class HrCustomFieldsComponent extends BaseComponent implements OnInit {
  effectiveDate = new FormControl<Date>(new Date());
  hrFields: HrFieldsResponse[] = [];

  loading = false;
  error: any = null;

  @HandleLoadingState()
  async ngOnInit(): Promise<void> {
    await this.populateHrFields();

    this.dispose.subs = this.effectiveDate.valueChanges.subscribe(async () => {
      if (this.isValidDate(this.effectiveDate.value)) {
        await this.populateHrFields();
      }
    });
  }

  @HandleLoadingState()
  async populateHrFields() {
    this.hrFields = await this.api.customFields.hrFields(
      getClaimKey(),
      this.effectiveDate.value,
    );
  }

  isValidDate(date: Date | null): boolean {
    return date instanceof Date && !isNaN(date.getTime());
  }
}
